<template>
  <div class="promotion-container">
    <!-- 推广入口按钮 -->
    <div class="promotion-entry">
      <a 
        href="javascript:void(0);" 
        class="entry-link"
        @click="showConfirmDialog"
      >
        <div class="entry-content">
          <span class="text">{{ buttonText }}</span>
        </div>
      </a>
    </div>

    <!-- 确认弹窗 -->
    <div v-if="showDialog" class="confirm-dialog-overlay" @click.self="cancelNavigation">
      <div class="confirm-dialog">
        <div class="dialog-header">
          <h3>温馨提示</h3>
        </div>
        <div class="dialog-content">
          <p>为避免影响您的用章体验</p>
          <p>申请资料如有疑问</p>
          <p>或申请电子印章付款后</p>
          <p>请致电客服电话：</p>
          <p>17760940848/15645372155</p>
        </div>
        <div class="dialog-actions">
          <button @click="confirmNavigation" class="btn-confirm">确定</button>
          <button @click="cancelNavigation" class="btn-cancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionWithConfirm',
  data() {
    return {
      promotionLink: 'https://www.itruscloud.com/certsaas_cloud_portal/#/home/sichuan-ca-two', // 替换为实际推广链接
      buttonText: '四川招投标电子印章',
      showDialog: false
    }
  },
  methods: {
    // 显示确认对话框
    showConfirmDialog() {
      this.showDialog = true;
    },
    // 确认跳转
    confirmNavigation() {
      this.showDialog = false;
      // 实际跳转逻辑
      window.open(this.promotionLink, '_blank');
      // 或者使用路由跳转：this.$router.push('/target-page');
    },
    // 取消跳转
    cancelNavigation() {
      this.showDialog = false;
    }
  }
}
</script>

<style scoped>
/* 推广按钮样式 - 保持原有设计 */
.promotion-container {
  position: relative;
}

.promotion-entry {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 80px;
  height: 80px;
  z-index: 10000;
}

.entry-link {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.entry-link:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(255, 107, 107, 0.5);
}

.entry-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
}

/* 弹窗样式 */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001; /* 确保在按钮上方 */
}

.confirm-dialog {
  background: white;
  border-radius: 12px;
  width: 320px;
  max-width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: dialog-appear 0.3s ease-out;
}

@keyframes dialog-appear {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.dialog-header {
  padding: 20px 20px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.dialog-content {
  padding: 20px;
  text-align: center;
}

.dialog-content p {
  margin: 0;
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

.dialog-actions {
  padding: 10px 20px 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.btn-confirm, .btn-cancel {
  padding: 10px 25px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
}

.btn-confirm {
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  color: white;
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.btn-cancel:hover {
  background: #eaeaea;
  transform: translateY(-2px);
}
</style>


// WEBPACK FOOTER //
// src/components/nav/nav-adv.vue